// @ts-expect-error $hasDep is untyped
export const DnDProviderCompat = $hasDep('react-dnd', '5') ?
// eslint-disable-next-line
require('./DnDProviderLatest').DnDProviderLatest :
// eslint-disable-next-line
require('./DnDProviderLegacy').DnDProviderLegacy;